import {Injectable} from '@angular/core';
import { HttpRequest, HttpHandler, HttpEvent, HttpInterceptor, HttpErrorResponse } from '@angular/common/http';

import {Observable, throwError} from 'rxjs';
import {catchError} from 'rxjs/operators';
import {Router} from '@angular/router';
import {ErrorMessagesConstants, RouterLinks} from '@core/constants';
import {UserService} from '@core/services';
import {ErrorLog} from '@core/models';
import {LogsService} from '../api-services/logs.service';

@Injectable()
export class ErrorInterceptor implements HttpInterceptor {
  constructor(private router: Router,
              private logService: LogsService,
              private userService: UserService) {
  }

  private internalServerErrorStatus = 500;

  intercept(request: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    return next.handle(request).pipe(
      catchError((err: HttpErrorResponse) => {
          this.handelError(err, request);
          return throwError(err);
        }
      ));
  }

  private handelError(err: HttpErrorResponse, request: HttpRequest<any>): void {
    if (err.status === this.internalServerErrorStatus && !request.url.includes('auth/error') ) {
      this.handleServerError(err, request);
      return;
    }
    switch (err.error.message) {
      case ErrorMessagesConstants.INVALID_TOKEN:
        this.handleTokenError();
        break;
      case  ErrorMessagesConstants.NOT_FOUND:
        this.handleNotFoundError();
        break;
    }
  }

  private handleServerError(err: HttpErrorResponse, request: HttpRequest<any>): void {
    const errorLog: ErrorLog = {
      error_message: err.message,
      params: {
        body: request.body || {},
        headers: request.headers
      },
      route: request.url
    };
    this.logService.setErrorLog(errorLog);
  }

  private handleTokenError(): void {
    this.userService.logout();
  }

  private handleNotFoundError(): void {
    this.router.navigate([RouterLinks.NOT_FOUND]);
  }
}
